export default "__VITE_ASSET__CtaAOTuK__"